import React from 'react'

import {UserAction} from '../actions/UserAction'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ADD_ACCESS_TOKEN, CHANGE_LANG, gaEvent, gaPageView, gaPageViewByPath, gaSet, validateEmail} from "../constants";
import AuthService from '../services/auth.service'
import {Collapse} from "reactstrap";
import {Button, Input, message, Modal, notification} from "antd";
import {KeyOutlined, MailOutlined, SafetyOutlined, UserOutlined} from "@ant-design/icons";
import {CommonAction} from "../actions/CommonAction";
import Language from "./Language";
import logoBlue from "../assets/img/logo/logo-blue.svg";
import i18n from "i18next";
import commonService from '../services/common.service';

class Login extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loginButtonLoading: false,
            registerButtonLoading: false,
            passChangeButtonLoading: false,
            timeLeft: 0,
            collapseSwitch: props.collapseSwitch ? props.collapseSwitch : 'login',
            name: "",
            surname: "",
            email: "",
            password: "",
            registerForm: {},
            forgetPassForm: {}
        }

        this.emailInput = React.createRef()

        this.checkRegistrationToken()
    }

    checkRegistrationToken() {
        const queryParams = new URLSearchParams(window.location.search)
        const registrationToken = queryParams.get("registrationToken") !== null ? queryParams.get("registrationToken") : ""
        const lang = queryParams.get("lang") !== null ? queryParams.get("lang") : ""

        if (!registrationToken) return

        if (lang) {
            i18n.changeLanguage(lang)
            this.props.commonAction(CHANGE_LANG, lang)
        }

        queryParams.delete("registrationToken")
        queryParams.delete("lang")

        this.checkToken(registrationToken, lang)
    }

    checkToken(token, lang) {
        AuthService.checkToken(token, lang)
            .then(
                response => {
                    let result
                    if (response.data && response.data.result) {
                        result = response.data.result

                        if (result === "already_registered") {
                            return
                        }

                        if (result === "valid") {
                            Modal.success({
                                centered: true,
                                content: i18n.t('register_token_valid'),
                                onOk() {
                                }
                            })
                        } else {
                            gaEvent("AuthService.checkToken Data Error - " + i18n.t('register_token_invalid'), "api data error")
                            message.error(i18n.t('register_token_invalid'))
                        }
                    }
                },
                error => {
                    gaEvent("AuthService.checkToken Error - " + i18n.t('global_error'), "api error")
                    message.error(i18n.t('global_error'))
                })
    }

    componentDidMount() {
        gaPageView()
        this.emailInput.current.focus();
    }

    handleKeyPress = (e) => {
        if (e.charCode === 13 || e.keyCode === 13) {
            this.login();
        }
    }

    login = () => {

        let email = this.state.email
        let password = this.state.password

        if (!validateEmail(email)) {
            return message.error(i18n.t('error_email'))
        }
        if (!password || password.trim() === "") {
            return message.error(i18n.t('error_password'))
        }

        this.setState({loginButtonLoading: true})

        AuthService.login(email, password)
            .then(
                response => {

                    this.setState({loginButtonLoading: false})

                    if (response.data.access_token) {
                        
                        const email = response.data.email
                        const name = response.data.name
                        const roles = response.data.roles
                        const access_token = response.data.access_token
                        const lang = response.data.lang || "en"
                        const uniqueKey = response.data.account_id ? response.data.account_id : "";
                        const user = {email, name, roles, accessToken: access_token, uniqueKey, lang};

                        i18n.changeLanguage(lang)
                        this.props.commonAction(CHANGE_LANG, lang)

                        AuthService.saveUser(user);
                        this.props.userAction(ADD_ACCESS_TOKEN, access_token);

                        gaSet(uniqueKey)
                    } else {
                        gaEvent("AuthService.login Data Error - " + i18n.t('global_error'), "api data error")
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {

                    this.setState({loginButtonLoading: false})

                    if (error.response && error.response.data.error === 'invalid_grant') {
                        gaEvent("AuthService.login Error - " + i18n.t('invalid_grant'), "api error")
                        message.error(i18n.t('invalid_grant'))
                    } else {
                        gaEvent("AuthService.login Error - " + i18n.t('global_error'), "api error")
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    setTimeLeft() {
        this.setState({timeLeft: 60})

        const intervalId = setInterval(() => {
            this.setState(prevState => ({
                timeLeft: prevState.timeLeft - 1
            }))
            if (this.state.timeLeft < 0) clearInterval(intervalId)
        }, 1000)
    }

    sendCode = () => {

        let email = this.state.forgetPassForm.email
        if (!validateEmail(email)) {
            return message.error(i18n.t('error_email'))
        }

        this.setTimeLeft()

        AuthService.sendVerificationCode(email)
            .then(
                response => {
                    if (response.status === 200) {
                        notification.open({
                            message: i18n.t('notification'),
                            description: i18n.t('verification_code_successful') + email,
                            icon: <SafetyOutlined style={{color: '#204f79'}}/>,
                        })
                    } else {
                        this.setState({timeLeft: 0});
                        gaEvent("AuthService.sendVerificationCode Data Error - " + i18n.t('global_error'), "api data error")
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    this.setState({timeLeft: 0});

                    gaEvent("AuthService.sendVerificationCode Error - " + i18n.t('global_error'), "api error")
                    message.error(i18n.t('global_error'))
                })
    }

    resetPassword = () => {

        let email = this.state.forgetPassForm.email
        let verificationCode = this.state.forgetPassForm.verificationCode
        let password = this.state.forgetPassForm.password

        if (!validateEmail(email)) {
            return message.error(i18n.t('error_email'))
        }
        if (!verificationCode || verificationCode.trim() === "") {
            return message.error(i18n.t('error_verificationCode'))
        }
        if (!password || password.trim() === "") {
            return message.error(i18n.t('error_password'))
        }
        if (password.length < 6) {
            return message.error(i18n.t('error_password_min'))
        }

        this.setState({passChangeButtonLoading: true})

        AuthService.resetPassword(email, verificationCode, password)
            .then(
                response => {

                    if (response.data && response.data.result === "code_valid") {

                        this.setState({
                            email: email,
                            password: password,
                            passChangeButtonLoading: false
                        });

                        setTimeout(function () {
                            this.login();
                        }.bind(this), 351);

                        // const email = response.data.email
                        // const name = response.data.name
                        // const roles = response.data.roles
                        // const access_token = response.data.access_token
                        // const uniqueKey = response.data.account_id ? response.data.account_id : "";
                        // const user = {email, name, roles, accessToken: access_token, uniqueKey};
                        //
                        // AuthService.saveUser(user);
                        // this.props.userAction(ADD_ACCESS_TOKEN, access_token)

                        message.info(i18n.t('reset_pass_successful'))
                    } else {
                        this.setState({passChangeButtonLoading: false})
                        gaEvent("AuthService.resetPassword Data Error - " + i18n.t('global_error'), "api data error")
                        message.error(i18n.t('verification_code_invalid'))
                    }
                },
                error => {
                    this.setState({passChangeButtonLoading: false})
                    gaEvent("AuthService.resetPassword Error - " + i18n.t('global_error'), "api error")
                    message.error(i18n.t('global_error'))
                }
            )
    }

    toggleCollapseSwitch(collapseSwitch) {
        this.setState({collapseSwitch: collapseSwitch})
        gaPageViewByPath('/' + collapseSwitch)
        gaEvent("Button Clicked on Login -> " + collapseSwitch, "button click")
    }

    handleInputChange = (e) => {
        const {name, value} = e.target
        this.setState({[name]: value})
    }

    handleRegisterInputChange = (e) => {
        const {name, value} = e.target
        this.setState(prevState => ({
            registerForm: {
                ...prevState.registerForm,
                [name]: value
            }
        }))
    }

    handleForgetPassInputChange = (e) => {
        const {name, value} = e.target
        this.setState(prevState => ({
            forgetPassForm: {
                ...prevState.forgetPassForm,
                [name]: value
            }
        }))
    }

    render() {

        let loginButtonLoading = this.state.loginButtonLoading
        let registerButtonLoading = this.state.registerButtonLoading
        let passChangeButtonLoading = this.state.passChangeButtonLoading

        return (
            <>
                <section className="h-100">
                    <div className="container h-100">
                        <div className="row">
                            <div className="col-12 align-items-start login-logo-lang">
                                <div className="row ml-1">
                                    <div className="login-logo">
                                        <img src={logoBlue} alt="Search Sanctions AML Solutions" title=""/>
                                    </div>
                                    <div className="login-lang ml-auto mr-3">
                                        <Language/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row h-100 login-form-row">
                            <div className="col-lg-5 align-self-center">

                                <div className="login-information custom-ant-input-wrapper">
                                    <Collapse isOpen={this.state.collapseSwitch === 'login'}>
                                        <h2>{i18n.t('login_now')}</h2>
                                        <form action="#" className="login-form">
                                            <div className="text-field">
                                                <Input type="email"
                                                       name="email"
                                                       placeholder={i18n.t('email')}
                                                       onKeyPress={this.handleKeyPress}
                                                       autoComplete="off"
                                                       ref={this.emailInput}
                                                       prefix={<MailOutlined/>}
                                                       onInput={this.handleInputChange}/>
                                            </div>
                                            <div className="password-field">
                                                <Input type="password"
                                                       name="password"
                                                       placeholder={i18n.t('password')}
                                                       onKeyPress={this.handleKeyPress}
                                                       autoComplete="off"
                                                       ref={this.emailInput}
                                                       prefix={<KeyOutlined/>}
                                                       onInput={this.handleInputChange}/>
                                            </div>
                                            <div className="signin-button-wrap">
                                                <Button
                                                    className="custom-button"
                                                    type="button"
                                                    onClick={this.login}
                                                    loading={loginButtonLoading}>
                                                    {i18n.t('login')}
                                                </Button>
                                                <div className="forgot-text">
                                                    <a className="custom-a"
                                                       onClick={() => {
                                                           this.toggleCollapseSwitch('forgetPassword')
                                                       }}>{i18n.t('forget_password')}</a>
                                                </div>
                                            </div>
                                        </form>
                                    </Collapse>
                                    <Collapse isOpen={this.state.collapseSwitch === 'forgetPassword'}>
                                        <h2>{i18n.t('change_password')}</h2>
                                        <p>{i18n.t('change_password_desc')}</p>
                                        <form action="#" className="login-form">
                                            <div className="email-field">
                                                <Input type="email"
                                                       name="email"
                                                       placeholder={i18n.t('email')}
                                                       autoComplete="off"
                                                       prefix={<MailOutlined/>}
                                                       onInput={this.handleForgetPassInputChange}/>
                                            </div>
                                            <div className="text-field">
                                                <Input type="text"
                                                       name="verificationCode"
                                                       id="verificationCode"
                                                       className="verificationCode w-50"
                                                       placeholder={i18n.t('verificationCode')}
                                                       autoComplete="off"
                                                       prefix={<UserOutlined/>}
                                                       onInput={this.handleForgetPassInputChange}/>
                                                <Button className=" verification-code-button"
                                                        disabled={this.state.timeLeft > 0}
                                                        type="button"
                                                        onClick={this.sendCode}>
                                                    {
                                                        this.state.timeLeft > 0
                                                            ?
                                                            this.state.timeLeft + i18n.t('send_code_wait')
                                                            :
                                                            i18n.t('send_code')
                                                    }
                                                </Button>
                                            </div>
                                            <div className="password-field">
                                                <Input type="text"
                                                       name="password"
                                                       placeholder={i18n.t('newPassword')}
                                                       autoComplete="off"
                                                       prefix={<KeyOutlined/>}
                                                       onInput={this.handleForgetPassInputChange}/>
                                            </div>
                                            <div className="signin-button-wrap">
                                                <Button
                                                    className="custom-button"
                                                    type="button"
                                                    onClick={this.resetPassword}
                                                    loading={passChangeButtonLoading}>
                                                    {i18n.t('reset_password')}
                                                </Button>
                                            </div>

                                            <div className="alternative-login">
                                                <span>{i18n.t('already_have_account')}</span>
                                                <a className="signup-link custom-a"
                                                   onClick={() => {
                                                       this.toggleCollapseSwitch('login')
                                                   }}>
                                                    {i18n.t('login_now')}
                                                </a>
                                            </div>
                                        </form>
                                    </Collapse>
                                </div>
                            </div>
                            <div className="col-lg-1 login-form-middle-col"/>
                            <div className="col-lg-6 h-100 d-flex align-items-center justify-content-center login-image">
                                <div className="row d-flex align-items-center justify-content-center">
                                    {/*<div className="col-12 login-favicon"><img src={faviconLogin} alt="Search Sanctions AML Solutions"/></div>*/}
                                    {/*<div className="col-12 login-logo-right"><img src={logoBlue} alt="Search Sanctions AML Solutions"/></div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);